import L from 'leaflet';
import moment from 'moment';

import { isSameLatLng } from '../util';

const LayerMixin = {
  props: {
    layers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      windfarmLayer: {
        1: require('@/asset/windfarm-layer-yellow.png'),
        2: require('@/asset/windfarm-layer-green.png'),
        3: require('@/asset/windfarm-layer-blue.png'),
        4: require('@/asset/windfarm-layer-purple.png')
      },
      towers: [],
      planes: [],
      bases: [],
      layerShapes: {
        towers: [],
        planes: [],
        bases: []
      }
    };
  },
  watch: {
    towers() {
      this.syncLayer('towers');
    },
    planes() {
      this.syncLayer('planes');
    },
    bases() {
      this.syncLayer('bases');
    },
    layers(val) {
      this.syncMapLayers(val);
    }
  },
  mounted() {
    if (!this.renderFuncs) this.renderFuncs = [];
    this.renderFuncs.push(this.syncLayers);
  },
  methods: {
    switchObjectLayer(data) {
      Object.keys(data).forEach(key => {
        this[key] = data[key];
      });
    },
    syncLayers() {
      this.syncLayer('towers');
      this.syncLayer('planes');
      this.syncLayer('bases');
    },
    getLayerIcon(type, data) {
      if (type === 'towers') {
        return L.icon({
          iconUrl: require('@/asset/tower-layer.png'),
          iconSize: [30, 30],
          iconAnchor: [15, 30]
        });
      }
      if (type === 'planes') {
        return L.icon({
          iconUrl:
            this.windfarmLayer[+data?.data?.stateId] || this.windfarmLayer[1],
          iconSize: [30, 30],
          iconAnchor: [15, 30]
        });
      }
      if (type === 'bases') {
        return L.icon({
          iconUrl: require('@/asset/base-layer.png'),
          iconSize: [30, 30],
          iconAnchor: [15, 30]
        });
      }
    },
    syncLayer(type) {
      const shapeArr = this.layerShapes[type];
      const dataArr = this[type] || [];
      const creatorMap = {
        planes: 'marker', // polygon
        towers: 'marker',
        bases: 'marker'
      };
      dataArr.forEach((data, i) => {
        if (!shapeArr[i]) {
          const opts = {};
          opts.icon = this.getLayerIcon(type, data);
          shapeArr[i] = L[creatorMap[type]](data, opts)
            .addTo(this.map)
            .on('click', () => this.clickLayerMarker(data));
        } else {
          if (!isSameLatLng(data, shapeArr[i].getLatLng())) {
            shapeArr[i].setLatLng(data);
          }
          shapeArr[i].setIcon(this.getLayerIcon(type, data));
        }
        shapeArr[i].bindTooltip(this.getTooltip(type, data));
        shapeArr[i].__data = data;
      });
      if (shapeArr.length > dataArr.length) {
        const removed = shapeArr.splice(
          dataArr.length,
          shapeArr.length - dataArr.length
        );
        removed.forEach(r => r.remove());
      }
    },
    clickLayerMarker(data) {
      this.$emit('clickLayerMarker', data);
    },
    switchCombinedLayer(combinedLayers) {
      this.syncMapLayers(combinedLayers, false);
    },
    syncMapLayers(layers = [], isProp = true) {
      let shapes;
      if (isProp) {
        if (!this.mapLayerShapes) this.mapLayerShapes = {};
        shapes = this.mapLayerShapes;
      } else {
        if (!this.innerMaplayerShapes) this.innerMaplayerShapes = {};
        shapes = this.innerMaplayerShapes;
      }
      const keys = Object.keys(shapes);
      layers.forEach(layer => {
        if (!shapes[layer.type]) {
          shapes[layer.type] = L.tileLayer(layer.url, {
            pane: 'layerPane',
            maxZoom: this.maxZoom,
            minZoom: this.minZoom,
            maxNativeZoom: layer.maxNativeZoom,
            reuseTiles: true,
            tms: layer.tms,
            opacity: layer.opacity || 1
          });
          this.map.addLayer(shapes[layer.type]);
        }
        const index = keys.indexOf(layer.type);
        if (index !== -1) {
          keys.splice(index, 1);
        }
      });
      keys.forEach(key => {
        this.map.removeLayer(shapes[key]);
        delete shapes[key];
      });
    },
    getTooltip(type, item) {
      const { data } = item;
      const date = 'YYYY-MM-DD HH:mm';
      const getRow = (title, value) => {
        return `<div class="leaflet-custom-tooltip-row">
          <div class="leaflet-custom-tooltip-row-title">${title}</div>
          <div class="leaflet-custom-tooltip-row-content">${value || '--'}</div>
        </div>`;
      };
      if (type === 'towers') {
        return `<div class="leaflet-custom-tooltip">
          <div class="leaflet-custom-tooltip-title">测风塔基本信息</div>
          ${getRow('测风塔编号', data.towerCode)}
          ${getRow('平均风速(m/s)', data.avgWspd)}
          ${getRow('风速高度(m)', data.wspdHeight)}
          ${getRow('风向高度(m)', data.wdirHeight)}
          ${getRow('代表年开始时间', moment(data.startDate).format(date))}
          ${getRow('代表年结束时间', moment(data.endDate).format(date))}
          ${getRow('海拔(m)', data.altitude || '0')}
          ${getRow('经纬度', data.lat + '°N,' + data.lon + '°E')}
          ${getRow('所属地', data.address)}
        </div>`;
      }
      if (type === 'bases') {
        let imgUrl = process.env.VUE_APP_API_HOST + '/windfarm' + data.image;
        return `<div class="leaflet-custom-tooltip">
          <p>基地名称: ${data.baseName || '--'}</p>
          <p>经纬度: ${data.lat + '°N,' + data.lon + '°E'}</p>
          <p>详细地址: ${data.address}</p>
          <p>基地简介: ${data.memo}</p>
          <p><img style='width:200px;height200px;' src='${imgUrl}'></img></p>
        </div>`;
      }
      return `<div class="leaflet-custom-tooltip">
        <p>工程名称：${data.projectName || '--'}</p>
        <p>业主：${data.name || '--'}</p>
        <p>地址：${data.address || '--'}</p>
        <p>状态：${data.stateName || '--'}</p>
        <p>描述：${data.description || '--'}</p>
        <p>经纬度: ${item.lat + '°N,' + item.lng + '°E'}</p>
        <p>台风次数：${data.counts || '0'}</p> 
      </div>`;
    },
    refreshObjectLayer(type) {
      this.$refs.control.refresh(type);
    }
  }
};

export default LayerMixin;
